/* eslint-disable prettier/prettier */
import React from "react";
import TugMetricsDetailsV2 from "../../../../components/common/TugMetricsDetailsV2";
import { SIDE_TUG_METRIC_TREND } from "../../../../routes/routerPath";

const TugSideMetricsDetailsV2 = (props) => (
  <TugMetricsDetailsV2
    {...props}
    reportType="side"
    trendPath={SIDE_TUG_METRIC_TREND}
  />
);
export default TugSideMetricsDetailsV2;
